export default function AppSection() {
  return (
    <section id="app" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-5xl mx-auto px-4 md:px-6">
        <div className="bg-background-50 rounded-2xl border border-background-200/70 overflow-hidden">
          <div className="flex flex-col lg:flex-row items-center">
            <div className="flex-1 p-8 md:p-12 text-center lg:text-left">
              <h2 className="text-xl md:text-3xl font-bold text-foreground-950 font-heading mb-4">
                随时随地，畅读漫画
              </h2>
              <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-6 max-w-md mx-auto lg:mx-0">
                下载樱花漫画APP，享受更流畅的阅读体验。支持iOS与安卓双平台，
                离线下载、追更提醒、多端同步等功能一应俱全。扫码或在应用商店搜索「樱花漫画」即可下载。
              </p>

              <div className="flex flex-col sm:flex-row items-center gap-3 justify-center lg:justify-start">
                <button className="inline-flex items-center gap-2 px-6 py-3 bg-foreground-950 text-background-50 rounded-lg font-medium text-sm hover:bg-foreground-800 transition-colors whitespace-nowrap cursor-pointer">
                  <i className="ri-apple-fill text-lg"></i>
                  App Store 下载
                </button>
                <button className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 text-background-50 rounded-lg font-medium text-sm hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer">
                  <i className="ri-google-play-fill text-lg"></i>
                  Google Play 下载
                </button>
              </div>

              <p className="mt-4 text-xs text-foreground-400">
                也可在华为、小米、OPPO等应用商店搜索下载
              </p>
            </div>

            <div className="flex-1 flex justify-center p-6 md:p-0">
              <div className="relative w-48 md:w-56 aspect-[3/4] rounded-xl overflow-hidden bg-background-100">
                <img
                  src="https://readdy.ai/api/search-image?query=Mobile%20app%20mockup%20showcasing%20manga%20reading%20interface%20on%20a%20smartphone%20screen%2C%20clean%20modern%20UI%20design%20with%20manga%20covers%20displayed%2C%20warm%20coral%20and%20cream%20color%20scheme%2C%20minimal%20app%20design%2C%20soft%20lighting%2C%20professional%20app%20showcase%2C%20warm%20cream%20background&width=500&height=667&seq=sakura-app-01&orientation=portrait"
                  alt="樱花漫画APP移动端阅读界面展示"
                  className="w-full h-full object-cover object-top"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}